import type { PipeTransform } from "@angular/core";
import { Pipe } from "@angular/core";

// Use this pipe to avoid change detection triggering functions used in templates
// i.e. {{ toReadableTime(item.start) }}                <- Incorrect (Function runs on every CD cycle)
//      {{ item.start | transform | toReadableTime }}   <- Correct (Function only runs if item.start changes)
@Pipe({
    name: 'transform',
    standalone: true
}) export class TransformPipe implements PipeTransform {

    transform(value: any, fn: (value: any) => any) {
        return fn(value);
    }
}